import { StatsigProvider, StatsigUser } from '@statsig/react-bindings';
import { useMemo } from 'react';

export function getStatsigProvider() {
  const statsigClientKey = import.meta.env.VITE_STATSIG_CLIENT_KEY as string;

  if (!statsigClientKey) {
    throw new Error('Missing Statsig Client Key');
  }

  return function StatsigProviderWrapper({ children }: { children: React.ReactNode }) {
    // Memoize the initial user to prevent re-renders
    const initialUser = useMemo<StatsigUser>(
      () => ({
        userID: 'anonymous'
      }),
      []
    );

    return (
      <StatsigProvider sdkKey={statsigClientKey} user={initialUser}>
        {children}
      </StatsigProvider>
    );
  };
}
